import {
  ChevronUp,
  EyeOff,
  RotateCcw,
} from "feather-icons-react/build/IconComponents";
import React, { useEffect, useState } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { setToogleHeader } from "../../../core/redux/action";
import SettingsSideBar from "../settingssidebar";
import Swal from "sweetalert2";
import { updateUser, getUserById } from "../../../service/ApiServices";
const SecuritySettings = () => {
  const [showPasswordFields, setShowPasswordFields] = useState(false);
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [id, setId] = useState("");
  const [user, setUser] = useState(null);
  const dispatch = useDispatch();
  const data = useSelector((state) => state.toggle_header);

  const renderRefreshTooltip = (props) => (
    <Tooltip id="refresh-tooltip" {...props}>
      Refresh
    </Tooltip>
  );
  const renderCollapseTooltip = (props) => (
    <Tooltip id="refresh-tooltip" {...props}>
      Collapse
    </Tooltip>
  );
  useEffect(() => {
    const storedUserData = localStorage.getItem("user");
    if (storedUserData) {
      const storeData = JSON.parse(storedUserData);
      setId(storeData.data._id);
    }
  }, []);
  useEffect(() => {
    const fetchUserDetails = async () => {
      if (!id) return; // wait until id is set
      try {
        const userData = await getUserById(id);
        setUser(userData);
        setPassword(userData.password);
        setConfirmPassword(userData.password);
      } catch (error) {
        Swal.fire({
          icon: "error",
          title: "Error...",
          text: error.message,
        });
      }
    };

    fetchUserDetails();
  }, [id]);

  const handleUpdateUser = async (e) => {
    e.preventDefault();

    try {
      await updateUser(id, {
        password,
        confirmPassword,
      });

      Swal.fire({
        icon: "success",
        title: "User Password Updated!",
        text: "The User Password has been updated successfully.",
      });
    } catch (error) {
      if (error) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: error.message,
        });
        return;
      }
    }
  };
  const handleCancel = () => {
    if (user) {
        setPassword(user.password || '');
        setConfirmPassword(user.password || '');
        handleTogglePassword()
        handleToggleConfirmPassword()
        setShowPasswordFields(false);
    }
  };
  const handleTogglePassword = () => {
    setShowPassword((prevShowPassword) => !prevShowPassword);
  };
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const handleToggleConfirmPassword = () => {
    setShowConfirmPassword((prevShowPassword) => !prevShowPassword);
  };
  return (
    <div>
      <div className="page-wrapper">
        <div className="content settings-content">
          <div className="page-header settings-pg-header">
            <div className="add-item d-flex">
              <div className="page-title">
                <h4>Settings</h4>
                <h6>Manage your settings on portal</h6>
              </div>
            </div>
            <ul className="table-top-head">
              <li>
                <OverlayTrigger placement="top" overlay={renderRefreshTooltip}>
                  <Link data-bs-toggle="tooltip" data-bs-placement="top">
                    <RotateCcw />
                  </Link>
                </OverlayTrigger>
              </li>
              <li>
                <OverlayTrigger placement="top" overlay={renderCollapseTooltip}>
                  <Link
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    id="collapse-header"
                    className={data ? "active" : ""}
                    onClick={() => {
                      dispatch(setToogleHeader(!data));
                    }}
                  >
                    <ChevronUp />
                  </Link>
                </OverlayTrigger>
              </li>
            </ul>
          </div>
          <div className="row">
            <div className="col-xl-12">
              <div className="settings-wrapper d-flex">
                <SettingsSideBar />
                <div className="settings-page-wrap">
                  <div className="setting-title">
                    <h4>Security</h4>
                  </div>
                  <div className="security-settings">
                    <ul>
                      <li>
                        
                        <div className="security-type">
                          <span className="security-icon">
                            <EyeOff />
                          </span>
                          <div className="security-title">
                            <h5>Password</h5>
                          </div>
                        </div>
                        <div className="security-btn">
                          <div className="security-btn">
                            <Link
                              to="#"
                              className="btn btn-primary"
                              onClick={() => setShowPasswordFields(true)}
                            >
                              Change Password
                            </Link>
                          </div>
                        </div>
                      </li>
                        {showPasswordFields && (
                          <>
                            <div className="col-lg-4">
                              <div className="input-blocks">
                                <label>Password</label>
                                <div className="pass-group">
                                  <input
                                    type={showPassword ? "text" : "password"}
                                    value={password}
                                    onChange={(e) =>
                                      setPassword(e.target.value)
                                    }
                                  />
                                  <span
                                    className={`fas toggle-password ${
                                      showPassword ? "fa-eye" : "fa-eye-slash"
                                    }`}
                                    onClick={handleTogglePassword}
                                  />
                                </div>
                              </div>
                            </div>

                            <div className="col-lg-4">
                              <div className="input-blocks">
                                <label>Confirm Password</label>
                                <div className="pass-group">
                                  <input
                                    type={
                                      showConfirmPassword ? "text" : "password"
                                    }
                                    value={confirmPassword}
                                    onChange={(e) =>
                                      setConfirmPassword(e.target.value)
                                    }
                                  />
                                  <span
                                    className={`fas toggle-password ${
                                      showConfirmPassword
                                        ? "fa-eye"
                                        : "fa-eye-slash"
                                    }`}
                                    onClick={handleToggleConfirmPassword}
                                  />
                                </div>
                              </div>
                            </div>
                            <div className="text-end settings-bottom-btn">
                              <button
                                type="button"
                                className="btn btn-cancel me-2"
                                onClick={handleCancel}
                              >
                                Cancel
                              </button>
                              <button
                                type="button"
                                className="btn btn-submit"
                                onClick={handleUpdateUser}
                              >
                                Save Changes
                              </button>
                            </div>
                          </>
                        )}
                      {/* <li>
                                                <div className="security-type">
                                                    <span className="security-icon">
                                                      
                                                        <Shield/>
                                                    </span>
                                                    <div className="security-title">
                                                        <h5>Two Factor</h5>
                                                        <p>Receive codes via SMS or email every time you login</p>
                                                    </div>
                                                </div>
                                                <div className="security-btn d-flex align-items-center">
                                                    <Link to="#" className="btn btn-danger">
                                                        Disable
                                                    </Link>
                                                    <div className="status-toggle modal-status d-flex justify-content-between align-items-center ms-2">
                                                        <input
                                                            type="checkbox"
                                                            id="user3"
                                                            className="check"
                                                            defaultChecked="true"
                                                        />
                                                        <label htmlFor="user3" className="checktoggle">
                                                            {" "}
                                                        </label>
                                                    </div>
                                                </div>
                                            </li>
                                            <li>
                                                <div className="security-type">
                                                    <span className="security-icon">
                                                        <Shield/>
                                                    </span>
                                                    <div className="security-title">
                                                        <h5>Google Authentication</h5>
                                                        <p>Connect to Google</p>
                                                    </div>
                                                </div>
                                                <div className="security-btn d-flex align-items-center">
                                                    <span className="badges-connected">Connected</span>
                                                    <div className="status-toggle modal-status d-flex justify-content-between align-items-center ms-2">
                                                        <input
                                                            type="checkbox"
                                                            id="user4"
                                                            className="check"
                                                            defaultChecked="true"
                                                        />
                                                        <label htmlFor="user4" className="checktoggle">
                                                            {" "}
                                                        </label>
                                                    </div>
                                                </div>
                                            </li>
                                            <li>
                                                <div className="security-type">
                                                    <span className="security-icon">
                                                        <Phone/>
                                                    </span>
                                                    <div className="security-title">
                                                        <h5>Phone Number Verification</h5>
                                                        <p>Verified Mobile Number : +81699799974</p>
                                                    </div>
                                                </div>
                                                <div className="security-btn d-flex align-items-center">
                                                    <span>
                                                        <i className=" fa fa-check-circle me-2" />
                                                    </span>
                                                    <Link to="#" className="btn btn-primary">
                                                        Change
                                                    </Link>
                                                    <Link to="#" className="remove-red ms-2">
                                                        Remove
                                                    </Link>
                                                </div>
                                            </li>
                                            <li>
                                                <div className="security-type">
                                                    <span className="security-icon">
                                                        <Mail/>
                                                    </span>
                                                    <div className="security-title">
                                                        <h5>Email Verification</h5>
                                                        <p>Verified Email : info@example.com</p>
                                                    </div>
                                                </div>
                                                <div className="security-btn d-flex align-items-center">
                                                    <span>
                                                        <i className=" fa fa-check-circle me-2" />
                                                    </span>
                                                    <Link to="#" className="btn btn-primary">
                                                        Change
                                                    </Link>
                                                    <Link to="#" className="remove-red ms-2">
                                                        Remove
                                                    </Link>
                                                </div>
                                            </li>
                                            <li>
                                                <div className="security-type">
                                                    <span className="security-icon">
                                                        <Tool/>
                                                    </span>
                                                    <div className="security-title">
                                                        <h5>Device Management</h5>
                                                        <p>Last Changed 22 July 2023, 10:30 AM</p>
                                                    </div>
                                                </div>
                                                <div className="security-btn d-flex align-items-center">
                                                    <Link to="#" className="manage-btn">
                                                        Manage
                                                    </Link>
                                                </div>
                                            </li>
                                            <li>
                                                <div className="security-type">
                                                    <span className="security-icon">
                                                        <Box/>
                                                    </span>
                                                    <div className="security-title">
                                                        <h5>Account Activity</h5>
                                                        <p>Last Changed 25 July 2023, 11:00 AM</p>
                                                    </div>
                                                </div>
                                                <div className="security-btn d-flex align-items-center">
                                                    <Link to="#" className="manage-btn">
                                                        View
                                                    </Link>
                                                </div>
                                            </li>
                                            <li>
                                                <div className="security-type">
                                                    <span className="security-icon">
                                                        <Slash/>
                                                    </span>
                                                    <div className="security-title">
                                                        <h5>Deactivate Account</h5>
                                                        <p>Last Changed 21 July 2023, 09:37 AM</p>
                                                    </div>
                                                </div>
                                                <div className="security-btn d-flex align-items-center">
                                                    <Link to="#" className="manage-btn">
                                                        Deactivate
                                                    </Link>
                                                </div>
                                            </li>
                                            <li>
                                                <div className="security-type">
                                                    <span className="security-icon">
                                                        <Trash2/>
                                                    </span>
                                                    <div className="security-title">
                                                        <h5>Delete Account</h5>
                                                        <p>Last Changed 26 July 2023, 11:40 AM</p>
                                                    </div>
                                                </div>
                                                <div className="security-btn d-flex align-items-center">
                                                    <Link to="#" className="btn btn-danger">
                                                        Delete
                                                    </Link>
                                                </div>
                                            </li> */}
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SecuritySettings;
